// Central content + assets for the Jollof Fit Kingdom website.

// General / support email — used for support, accounts, privacy, GDPR and account deletion.
export const SUPPORT_EMAIL = "jolloffitkingdom@gmail.com";
// Business partnerships email — used only for partnership / device / OEM / distribution inquiries.
export const PARTNERSHIP_EMAIL = "partnerships.jolloffit@gmail.com";
// Default general contact alias.
export const CONTACT_EMAIL = SUPPORT_EMAIL;

export const COMPANY = "Jollof Fit Kingdom";
export const EFFECTIVE_DATE = "June 1, 2026";

export const IMAGES = {
  // Official brand assets only
  jfLogo: "/jollof-jf-logo.png",
  eagle: "/jollof-eagle.jpg",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Features", to: "/features" },
  { label: "Smart Scale", to: "/smart-scale" },
  { label: "Kingdom Score", to: "/kingdom-score" },
  { label: "Partnerships", to: "/business-partnerships" },
  { label: "Contact", to: "/contact" },
];

export const FEATURE_LINKS = [
  { label: "Coaching", to: "/coaching" },
  { label: "Workout Tracking", to: "/workout-tracking" },
  { label: "Nutrition", to: "/nutrition" },
  { label: "Kingdom Insights", to: "/kingdom-insights" },
];

export const DEVICE_CATEGORIES = [
  "Smart Scales",
  "Wearables",
  "Heart-Rate Monitors",
  "Sleep Trackers",
  "Recovery Devices",
  "Body Sensors",
  "Fitness Bands",
  "Connected Health",
];

export const CORE_FEATURES = [
  {
    icon: "Sparkles",
    title: "Personalized Coaching",
    slug: "coaching",
    desc: "Personalized coaching that adapts every plan to your body, goals and daily performance.",
  },
  {
    icon: "Dumbbell",
    title: "Workout Tracking",
    slug: "workout-tracking",
    desc: "Log, analyze and optimize every session with automatic volume, intensity and progression insights.",
  },
  {
    icon: "Apple",
    title: "Nutrition",
    slug: "nutrition",
    desc: "Nutrition tracking that connects what you eat to how you perform and recover.",
  },
  {
    icon: "Footprints",
    title: "Step Tracking",
    slug: "features",
    desc: "Daily movement captured and synced across your connected devices, effortlessly.",
  },
  {
    icon: "Scale",
    title: "Body Composition",
    slug: "smart-scale",
    desc: "Weight, body fat, muscle and hydration synced directly from compatible smart scales.",
  },
  {
    icon: "Crown",
    title: "Kingdom Score",
    slug: "kingdom-score",
    desc: "A single score that unifies your training, nutrition, recovery and health.",
  },
  {
    icon: "LineChart",
    title: "Kingdom Insights",
    slug: "kingdom-insights",
    desc: "Personalized insights that explain your body and guide your next move.",
  },
  {
    icon: "Camera",
    title: "Progress Photos",
    slug: "features",
    desc: "Capture and compare private progress photos to see your transformation over time.",
  },
  {
    icon: "Trophy",
    title: "Achievements",
    slug: "features",
    desc: "Meaningful goals and rewards that keep you consistent for the long run.",
  },
  {
    icon: "HeartPulse",
    title: "Health Synchronization",
    slug: "features",
    desc: "Unified health data across wearables, scales and platforms in one connected hub.",
  },
];
